import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chat-container" }

import { TUIChat } from "@/TUIKit/components";
import { TUIConversationService } from "@tencentcloud/chat-uikit-engine";
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted } from "vue";
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref } from "vue";
import { useRoute } from "vue-router";

export default /*@__PURE__*/_defineComponent({
  __name: 'chat',
  setup(__props) {

const conversationType = ref()
const conversationID = ref()
const userName = ref()

onMounted(() => {
  //从路由获取参数
  const route = useRoute()
  //C2C、GROUP
  conversationType.value = route.query.conversationType
  conversationID.value = route.query.conversationID
  userName.value = route.query.userName
  TUIConversationService.switchConversation(conversationType.value + conversationID.value);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomTitleBar, {
      title: _unref(TUITranslateService).t(userName.value),
      fixed: true,
      zIndex: 10
    }, null, 8, ["title"]),
    _createVNode(_unref(TUIChat))
  ]))
}
}

})